module.exports = __webpack_public_path__ + "img/icon-search.fa769825.svg";